/**
 * Approved 19 Oct 2026 Professional Map photographic assets.
 * Image-only artworks: all headings, labels, search and actions remain DOM text.
 * No generated/resynthesized visuals and no live data/people represented.
 */
export const PROFESSIONAL_MAP_ARTWORK = {
  entryCards: {
    masters: "/professional-map/entry-masters.webp",
    suppliers: "/professional-map/entry-suppliers.webp",
    services: "/professional-map/entry-services.webp",
    vacancies: "/professional-map/entry-work.webp",
  },
  mainHeroDesktop: "/professional-map/hero-main-desktop.webp",
  mainHeroMobile: "/professional-map/hero-main-mobile.webp",
  mastersHeroDesktop: "/professional-map/hero-masters-desktop.webp",
  suppliersHeroDesktop: "/professional-map/supplier-hero-desktop.webp",
  suppliersHeroMobile: "/professional-map/supplier-hero-mobile.webp",
  suppliersCategories: {
    "Ингредиенты": "/professional-map/supplier-ingredients.webp",
    "Упаковка": "/professional-map/supplier-packaging.webp",
    "Оборудование и инвентарь": "/professional-map/supplier-equipment-inventory.webp",
    "Цеха и производства": "/professional-map/supplier-production.webp",
  },
  workHeroDesktop: "/professional-map/work-hero-desktop.webp",
  workHeroMobile: "/professional-map/work-hero-mobile.webp",
  workCategories: {
    "Вакансии": "/professional-map/work-vacancies.webp",
    "Ищу работу": "/professional-map/work-seeking.webp",
    "Партнёрство и проекты": "/professional-map/work-partnership.webp",
  },
  mastersCategories: {
    "Кондитеры": "/professional-map/master-confectioners.webp",
    "Декораторы": "/professional-map/master-decorators.webp",
    "Технологи": "/professional-map/master-technologists.webp",
    "Преподаватели": "/professional-map/master-teachers.webp",
    "Профильные специалисты": "/professional-map/master-specialists.webp",
  },
  servicesHeroDesktop: "/professional-map/services-hero-desktop.webp",
  servicesHeroMobile: "/professional-map/services-hero-mobile.webp",
  servicesCategories: {
    "Фотосъёмка": "/professional-map/services-photography.webp",
    "Дизайн и брендинг": "/professional-map/services-branding.webp",
    "Печать": "/professional-map/services-print.webp",
    "Доставка": "/professional-map/services-delivery.webp",
    "Праздники и мероприятия": "/professional-map/services-events.webp",
  },
};

